import { Injectable } from "@angular/core";
import { ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { NavigationStateService } from "src/app/services/navigation-state.service";
import { PageStatusService } from "src/app/services/page-status.service";

@Injectable({
    providedIn: 'root'
})
export class PreventBackButtonGuard {
    constructor(
        private toastController: ToastController,
        private translateService: TranslateService,
        private pageService: PageStatusService,
        private navigationStateService: NavigationStateService
    ) {}

    canDeactivate = async () => {
        if(!this.navigationStateService.isAuth) {
            return true;
        }

        if(history?.state?.tab == 'submitted') {
            return true;
        }
        if(history.state == null) {
            if(!this.pageService.isConfirmationPage()){
                return true;
            }
        }
        if(this.navigationStateService.stopEnrolment) {
            return true;
        }

        const toast = await this.toastController.create({
            message: this.translateService.instant('COMMON.TOAST.USE_APP_BUTTONS'),
            duration: 2000,
            color: 'warning',
            position: 'middle'
        });
        toast.present();
        return false;
    }
}
